import { cloneDeep, set } from "lodash";
import store from "../../../../../store";
import i18n from "../../../../../Utils/i18next/i18next";
import { GlobalAuthFetch } from "../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import { NotificationManager } from "react-notifications";

const { t } = i18n;

export const onSubmit = async (values, props) => {
  const { secretReducer } = store.getState();
  const {
    updateTableRegistry,
    loadData,
    update,
    updateSingleRegistry,
    uuid,
    initialValues,
  } = props;

  const data = cloneDeep(values);

  let payload;

  if (!update) {
    data.status = secretReducer?.availableStatuses.find(
      (el) => !!el.isSelected,
    );

    const res = await GlobalAuthFetch({
      path: `/secret/resource/${uuid}`,
      method: "POST",
      data,
    });
    payload = res.payload;
  }

  if (update) {
    const res = await GlobalAuthFetch({
      path: `/secret/resource`,
      method: "PATCH",
      data,
    });
    payload = res.payload;
  }

  if (payload?.status >= 300 || !payload?.status) {
    props.setErrorHeader(0, true);

    return;
  }

  props.setErrorHeader(0, false);

  //Succes nofify
  loadData();
  NotificationManager.success(i18n.t("global:success"));
  if (updateSingleRegistry) updateSingleRegistry();
  if (updateTableRegistry) updateTableRegistry();

  props.handleHide();
};

export const onValidate = (values, props) => {
  const { update } = props;
  const errorsStep0 = {};

  if (!values.systemName) {
    errorsStep0.systemName = t("global:secret.errors.systemName");
  }
  if (!values.credentials) {
    errorsStep0.credentials = t("global:secret.errors.credentials");
  }

  if (
    !props.steps[0]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep0).length > 0
  ) {
    props.setErrorHeader(0, true);
  }
  if (
    !!props.steps[0]?.error &&
    !props.isSubmit &&
    Object.keys(errorsStep0).length <= 0
  ) {
    props.setErrorHeader(0, false);
  }

  return { ...errorsStep0 };
};
